// extracted by mini-css-extract-plugin
export var dataCell = "_lp-2";
export var dataRow = "_lp-0";
export var headerRow = "_lp-1";